import React, { useEffect, useState } from "react";
import { messaging } from "../../firebase"; // Adjust the import path if needed
import { getToken, onMessage } from "firebase/messaging";
import ApiService from "../../api/ApiService";

const NotificationComponent = (userId) => {
  const [notification, setNotification] = useState(null);
  console.log("MESSSSSSS", messaging);

  useEffect(() => {
    const requestPermission = async () => {
      try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
          const token = await getToken(messaging, {
            vapidKey:
              "BFDdVL5jaAMlXbgIcFaRGNTqRutnF4oAP4m0YWmS7I4x8p_tuS9B-mFi8nERaD1hZXOH-4xtn0aHyCNvM48DzlU",
          });
          if (token) {
            console.log("✅ FCM Token:", token);

            const data = { userId: userId, token: token };
            // Send token to backend using ApiService
            await ApiService.saveToken(data);
            console.log("✅ Token sent to backend!");
          }
        } else {
          console.log("Permission denied");
        }
      } catch (error) {
        console.error("Error getting permission:", error);
      }
    };

    requestPermission();

    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("Message received:", payload);
      setNotification(payload.notification);
    });

    return () => unsubscribe();
  }, []);

  return (
    <div>
      {notification && (
        <div className="notify-div">
          <h4>{notification.title}</h4>
          <p>{notification.body}</p>
          <button
            onClick={() => setNotification(null)}
            className="notify-button"
          >
            Dismiss
          </button>
        </div>
      )}
    </div>
  );
};

export default NotificationComponent;
